//
// Business definitions
//

export type BusinessType =
  | "appointment"
  | "bill"
  | "consult_clubfoot"
  | "consult_other"
  | "consult_ricket"
  | "patient"
  | "payment"
  | "price"
  | "picture"
  | "surgery"
  | "user"
  //
  // Legacy
  //
  | "pojo";

export const icons = {
  error: "/static/img/error.svg",
  logout: "/static/img/logout.gif",
  models: {
    appointment: "/static/img/model_appointment.gif",
    bill: "/static/img/model_bill.svg",
    consult_clubfoot: "/static/img/model_consult_clubfoot.svg",
    consult_other: "/static/img/model_consult_other.svg",
    consult_ricket: "/static/img/model_consult_ricket.svg",
    patient: "/static/img/model_patient.gif",
    payment: "/static/img/model_payment.svg",
    picture: "/static/img/model_picture.svg",
    surgery: "/static/img/model_surgery.png"
  } as Record<BusinessType, string>
};

export function type2Title(type: BusinessType) {
  switch (type) {
    case "appointment":
      return "Appointment";
    case "bill":
      return "Bill";
    case "consult_clubfoot":
      return "Consult. Clubfoot";
    case "consult_other":
      return "Consult. Other";
    case "consult_ricket":
      return "Consult. Ricket";
    case "patient":
      return "Patient";
    case "payment":
      return "Payment";
    case "picture":
      return "Picture";
    case "price":
      return "Price";
    case "surgery":
      return "Surgery";
    case "user":
      return "User";
    default:
      throw new Error(`Unknown type ${type} in type2Title`);
  }
}
